import { useContentHelpers } from './content/useContentHelpers';
import { useLinkHelpers } from './links/useLinkHelpers';
import { useChipHelpers } from './chips/useChipHelpers';
import { useComponentHelpers } from './component/useComponentHelpers';
export var useEditorHelpers = function (editorState, setEditorState, referenceCollection, setReferenceCollection, onChipClick, disabled) {
    var componentHelper = useComponentHelpers(disabled);
    var contentHelper = useContentHelpers(editorState, setEditorState);
    var linksHelper = useLinkHelpers(editorState, setEditorState, componentHelper.editorReference);
    var chipsHelper = useChipHelpers(editorState, setEditorState, referenceCollection, setReferenceCollection, onChipClick);
    return [
        componentHelper,
        contentHelper,
        linksHelper,
        chipsHelper,
    ];
};
//# sourceMappingURL=EditorBag.js.map